<template>
  <div class="ExamOnline">
    <TopNavBar navtitle="选择考试曲目"></TopNavBar>
    <div class="enrolllist" v-if="ExamFromInfo">
      <ul class="examinfo">
        <h1>{{ ExamFromInfo.ExamBatch.EB_Name }}</h1>
        <img
          class="papers"
          :src="ExamFromInfo.Photo"
          :alt="ExamFromInfo.Name"
        />
        <li>
          <label for="">姓名：</label>
          <span>{{ ExamFromInfo.Name }}</span>
        </li>
        <li>
          <label for="">准考证号：</label>
          <span>{{ ExamFromInfo.ExamNO }}</span>
        </li>
        <li>
          <label for="">专业：</label>
          <span class="warning">{{ ExamFromInfo.Majors.MName }}</span>
        </li>
        <li>
          <label for="">级别：</label>
          <span class="warning">{{ ExamFromInfo.Grades.GName }}</span>
        </li>
      </ul>
      <ul class="examask">
        <h1>
          考试项目：{{ ExamFromInfo.Majors.MName }}
          {{ ExamFromInfo.Grades.GName }}
        </h1>
        <p class="small">注：当前操作是为线下考试进行曲目选择。</p>
        <p class="danger small">
          现场考试起止日期：{{ ExamFromInfo.ExamTime.ExamBeginDate }} 至
          {{ ExamFromInfo.ExamTime.ExamEndDate }}
        </p>
        <div v-for="QuestionInfo in QuestionList" :key="QuestionInfo.EQT_ID">
          <div v-if="AnswerSheetList && AnswerSheetList.length > 0">
            <li
              v-for="(Answer, index) in AnswerSheetList.filter(
                s => s.EQT_ID == QuestionInfo.EQT_ID
              )"
              :key="Answer.EAS_ID"
            >
              <p>
                <label for=""
                  >{{ QuestionInfo.TypeName }}({{ chin_list[index] }})</label
                >
                <span class="refer">
                  <model-list-select
                    :list="QuestionInfo.ExamQuestions"
                    v-model="Answer.EQ_ID"
                    :placeholder="'请选择' + QuestionInfo.TypeName"
                    option-value="EQ_ID"
                    option-text="Question"
                  ></model-list-select>
                </span>
              </p>
            </li>
          </div>
          <div v-if="!AnswerSheetList || AnswerSheetList.length == 0">
            <li
              v-for="n in QuestionInfo.InitNum"
              :key="QuestionInfo.EQT_ID + n"
            >
              <p>
                <label for=""
                  >{{ QuestionInfo.TypeName }}({{ chin_list[n - 1] }})</label
                >
                <span class="refer">
                  <model-list-select
                    :list="
                      QuestionInfo.ExamQuestions.filter(f => {
                        return (
                          (getObjectValues(uploader).indexOf(f.EQ_ID) == -1 &&
                            getNames(uploader, f.Question).indexOf(
                              f.Question
                            ) == -1) ||
                          (uploader[QuestionInfo.EQT_ID + '#' + n] &&
                            uploader[QuestionInfo.EQT_ID + '#' + n] == f.EQ_ID)
                        );
                      })
                    "
                    v-model="uploader[QuestionInfo.EQT_ID + '#' + n]"
                    :placeholder="'请选择' + QuestionInfo.TypeName"
                    option-value="EQ_ID"
                    option-text="Question"
                  ></model-list-select>
                </span>
              </p>
            </li>
          </div>
          <div
            v-if="
              AnswerSheetList &&
                AnswerSheetList.length > 0 &&
                AnswerSheetList.filter(s => s.EQT_ID == QuestionInfo.EQT_ID)
                  .length < QuestionInfo.InitNum
            "
          >
            <li
              v-for="n in QuestionInfo.InitNum -
                AnswerSheetList.filter(s => s.EQT_ID == QuestionInfo.EQT_ID)
                  .length"
              :key="QuestionInfo.EQT_ID + n"
            >
              <p>
                <label for=""
                  >{{ QuestionInfo.TypeName }}({{
                    chin_list[
                      AnswerSheetList.filter(
                        s => s.EQT_ID == QuestionInfo.EQT_ID
                      ).length +
                        n -
                        1
                    ]
                  }})</label
                >
                <span class="refer">
                  <model-list-select
                    :list="
                      QuestionInfo.ExamQuestions.filter(
                        s =>
                          AnswerSheetList.filter(a => a.EQ_ID == s.EQ_ID)
                            .length == 0
                      )
                    "
                    v-model="uploader[QuestionInfo.EQT_ID + '#' + n]"
                    :placeholder="'请选择' + QuestionInfo.TypeName"
                    option-value="EQ_ID"
                    option-text="Question"
                  ></model-list-select>
                </span>
              </p>
            </li>
          </div>
        </div>
      </ul>
    </div>

    <div class="upvbtn" v-if="AnswerSheetList && AnswerSheetList.length > 0">
      <van-button
        @click="
          () => {
            AnswerSheetList = [];
          }
        "
        type="primary"
        >重新选择</van-button
      >
    </div>
    <div class="upvbtn" v-else>
      <van-button
        @click="SubAllAnswer"
        block
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        ><i class="iconfont icon-shangchuanshipin1"></i>
        确认曲目选择</van-button
      >
    </div>
    <van-dialog
      v-model="SeleBook"
      title="选择教材，选择以后将不能更改，请谨慎选择"
      confirm-button-text="确定"
      :before-close="beforeSelectBook"
    >
      <p v-for="item in Books" :key="item.TB_ID" style="padding: 15px 10px">
        <van-button
          :type="TB_ID == item.TB_ID ? 'primary' : 'default'"
          plain
          hairline
          @click="TB_ID = item.TB_ID"
          >{{ item.BookName }}</van-button
        >
      </p>
    </van-dialog>
  </div>
</template>
<script>
import TopNavBar from "@/components/TopNavBar.vue";
import Ticket from "@/components/Ticket.vue";
import {
  ExamFromPatternList,
  GetExamFormInfo,
  GetAnswerSheetList,
  GetExamQuestionList,
  SubAnswer,
  GetExamTextBookList,
  SelectTextBook,
  SetOfflineExamTracks
} from "@/api/exam";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { ImagePreview } from "vant";

export default {
  components: {
    TopNavBar,
    Ticket,
    ModelListSelect
  },
  data() {
    return {
      TB_ID: 0,
      buttoncolor: "",
      buttontext: "5秒后确认",
      subState: false,
      showAllSub: false,
      SeleBook: false,
      IsSub: 0,
      task: null,
      vshow: false,
      active: 0,
      value: 1,
      par: 0,
      Books: null,
      pshow: false,
      currentRate: 0,
      UpText: "",
      ExamFromInfo: null,
      ExamPatternList: null,
      AnswerSheetList: null,
      IsRandom: false,
      EF_ID: 0,
      AnswerInfo: null,
      QuestionList: null,
      Questions: [],
      option: [
        { text: "点击选择上传曲目名称", value: 1 },
        { text: "乐理基础知识2", value: 2 },
        { text: "乐理基础知识3", value: 3 }
      ],
      uploader: [],
      chin_list: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"]
    };
  },
  created() {
    if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
      this.EF_ID = this.$route.query.EF_ID;
      this.GetExamFormInfo(this.EF_ID);
      this.GetExamFromPatternList(this.EF_ID);
      this.getAnswerSheetList();
    } else {
      this.$router.push("/MyEnroll");
    }
  },
  methods: {
    getNames(object, name) {
      var values = [];
      for (var property in object)
        values.push(
          this.Questions.find(f => f.EQ_ID == object[property]).Question
        );

      return values;
    },
    getObjectValues(object) {
      var values = [];
      for (var property in object) values.push(object[property]);
      return values;
    },

    ShowMusicScore(MusicScore) {
      let imgList = MusicScore.split(",");
      if (imgList.length > 0) {
        ImagePreview({ images: imgList, closeable: true });
      }
    },

    GetExamQuestionList(MID, GID, TB_ID) {
      GetExamQuestionList({ MID: MID, GID: GID, TB_ID: TB_ID }).then(res => {
        this.QuestionList = [];
        res.listData.forEach(item => {
          if (item.ExamQuestions != null && item.ExamQuestions.length > 0) {
            this.QuestionList.push(item);
            this.Questions = [...this.Questions, ...item.ExamQuestions];
          }
        });
      });
    },
    GetExamFromPatternList(EF_ID) {
      if (!EF_ID || EF_ID == 0) {
        this.$toast.fail({ message: "请选择要上传考试视频的报名信息" });
        return;
      }
      ExamFromPatternList({ EF_ID: EF_ID }).then(res => {
        this.ExamPatternList = res.listData;
      });
    },
    GetExamFormInfo(EF_ID) {
      GetExamFormInfo({ EF_ID: EF_ID })
        .then(res => {
          this.ExamFromInfo = res.item;
          if (res.item.TB_ID == 0) {
            this.GetExamTextBookList();
          }
          if (res.item.TB_ID != 0 || !this.Books) {
            this.GetExamQuestionList(
              res.item.MID,
              res.item.GID,
              res.item.TB_ID
            );
          }
        })
        .catch(err => {});
    },
    GetExamTextBookList() {
      GetExamTextBookList({ MID: this.ExamFromInfo.MID, IsSub: 1 }).then(
        res => {
          this.Books = res.listData;
          if (this.Books && this.Books.length > 0) {
            this.SeleBook = true;
          }
        }
      );
    },
    getAnswerSheetList() {
      GetAnswerSheetList({ EF_ID: this.$route.query.EF_ID }).then(res => {
        this.AnswerSheetList = res.listData;
      });
    },

    SubAllAnswer() {
      let EQ_ID_List = this.getObjectValues(this.uploader);
      if (EQ_ID_List.length < this.QuestionList.length) {
        this.$toast.fail({ message: "请选择所有曲目" });
        return;
      }
      SetOfflineExamTracks({
        EF_ID: this.EF_ID,
        EQ_ID: EQ_ID_List.join(",")
      }).then(res => {
        this.$toast.success({ message: "提交成功" });
        this.$router.push("/MyEnroll?EF_ID=" + this.EF_ID);
        this.subState = false;
      });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.subState === false) {
          done(false);
          return;
        }
        var count =
          (this.ExamPatternList ? this.ExamPatternList.length : 0) +
          (this.QuestionList ? this.QuestionList.length : 0);
        SubAnswer({ EF_ID: this.EF_ID, Count: count })
          .then(res => {
            this.$toast.success({ message: "视频上传成功" });
            this.$refs.timer.reset();
            this.IsSub = 1;
            done();
          })
          .catch(() => {
            done();
          });
      } else {
        done();
      }
    },
    beforeSelectBook(action, done) {
      if (action === "confirm") {
        if (this.TB_ID === 0) {
          this.$toast.fail({ message: "请选择教材" });
          done(false);
          return;
        }
        SelectTextBook({ EF_ID: this.EF_ID, TB_ID: this.TB_ID })
          .then(res => {
            this.$toast.success({ message: "教材选择成功" });
            location.reload();
            done();
          })
          .catch(() => {
            done();
          });
      }
      done(false);
    }
  }
};
</script>

<style>
.enrolllist .examask li {
  display: block;
}
.enrolllist .examask li p {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 3.2vw;
}
.enrolllist .examask li p label {
  font-weight: bold;
}
.enrolllist .examask li p span.refer {
  width: 60%;
}
.enrolllist .examask li p .refer .ui.search.dropdown > input.search {
  width: auto;
}
.enrolllist .examask li p span.refer .dropdown {
  padding: 8px;
}
.enrolllist .examask li p span.refer .ui.search.dropdown > .text {
  line-height: 1.5;
}
.enrolllist .examask .danger {
  margin: 5px 0;
}
.enrolllist .examask .danger .van-count-down {
  display: initial;
  font-size: 4.8vw;
}
.UploadVideo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: rgba(3, 3, 3, 0.6);
}
.UploadVideo .van-circle {
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -50px;
}
.UploadVideo p,
.UploadVideo .van-circle__text {
  color: #fff;
  padding: 15px;
  line-height: 1.5;
  font-size: 4.8vw;
}
.UploadVideo .van-circle__text {
  font-weight: bold;
}
.UploadVideo p span {
  font-size: 3vw;
}
.upvbtn .disabled {
  background: #888;
  color: #fff;
  border: 0;
}
.upvbtn .disabled .van-button__content .van-button__text {
  font-size: 3.6vw;
}
.van-dialog {
  width: 96%;
}
</style>
